module.exports = __webpack_public_path__ + "img/u89.0e95c75b.svg";